<template>
  <div id="content">
    <div class="page-title">帮助指南
      <div style="height: 8px"></div>
    </div>
    <div divalign="center" style="font-size: 16px">
      <div class="page-title1">VIVO手机推送相关设置
        <div style="height: 8px"></div>
      </div>
      <p class="page-title2">在叮咚—App设置—开启通知权限里进行设置（以VIVO X9s为参考，Android8系统）</p>
      <img src="./vivo1.png" class="bg"/>
      <p class="page-title2">点击自启动权限去开启</p>
      <p class="page-title2">1.按照图示开启以下权限</p>
      <img src="./vivo2.png" class="bg"/>

      <p class="page-title2">2.此页面接着设置通知，如下图2中，分别将设置项</p>
      <p class="page-title2">【普通】【重要】【DingDongApp-Channel】【DingDongUpdate-Channel】【系统默认通道】参照</p>

      <p class="page-title2">下图3图4设置相关项。</p>

      <img src="./vivo3.png" class="bg"/>
      <p class="page-title2">3.最后一步，在手机设置—电池—后台高耗电开关开启</p>
      <img src="./vivo4.png" class="bg"/>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'no_bind'
  }
</script>

<style scoped>
  .page-title {
    font-size: 18px;
    margin: 20px auto;
    text-align: center;
    display: block;
    line-height: 1;
    left: 118px;
    border-width: 0 0 1px 0;
    font-family:blod  黑体 ;
    font-weight:900;
    border-style: solid;
    border-color: #F5F5F5;
  }

  .page-title1 {
    font-family:blod 黑体;
    font-weight:100;

    font-size: 18px;
    margin: 20px auto;
    line-height: 1;
    left: 14px;
    border-width: 0 0 1px 0;

    border-style: solid;
    border-color: #F5F5F5;
  }

  .page-title2 {
    left: 14px;
    height: 26px;
    font-family: 简体;
    font-size: 16px;
    color: #666666;
  }

  .bg {
    width: 100%;
    height: 100%;
    margin: 0 auto;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/commonproblem/nobindmsg/vivo/vivo.vue